module.exports = __webpack_public_path__ + "static/media/carousel-new-2.8b0e02a1.png";